"use client";

import { useEffect } from "react";
import Bugsnag from "@bugsnag/js";

import { env } from "@/env";
import ErrorBlock from "@/components/molecules/ErrorBlock";
import { usePathnameLocale } from "@/hooks/usePathnameLocale";

interface ErrorPageProps {
  error: Error;
  reset: () => void;
}

const CHUNK_RELOAD_KEY = "chunkErrorReloadCount";
const MAX_CHUNK_RELOADS = 2;

const ErrorPage = ({ error, reset }: ErrorPageProps) => {
  useEffect(() => {
    if (error?.name === "ChunkLoadError") {
      const reloadCount = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || "0");

      if (reloadCount < MAX_CHUNK_RELOADS) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, String(reloadCount + 1));
        window.location.reload();
        return;
      }

      // Max retries reached — reset counter so future navigations can retry again
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    }

    console.error(error);
  }, [error]);

  const locale = usePathnameLocale();

  return (
    <main className="grid place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <ErrorBlock locale={locale} error={error} reset={reset} />
    </main>
  );
};

export default ErrorPage;
